/** Marca de una incidencia en la nota del contacto (spec 065 del panel). */
export const MARCA_INCIDENCIA = 'Incidencia.'

export function textoIncidencia(texto: string): string {
    return `${MARCA_INCIDENCIA}\n${texto.trim()}`
}

export function esIncidencia(contenido: string): boolean {
    return contenido.startsWith(`${MARCA_INCIDENCIA}\n`) || contenido === MARCA_INCIDENCIA
}

export function cuerpoNota(contenido: string): string {
    if (!esIncidencia(contenido)) return contenido
    return contenido.slice(MARCA_INCIDENCIA.length).replace(/^\n/, '')
}

/**
 * Cuántas notas caben en la ventana.  (spec 037 · FR-006)
 *
 * Al equipo es estrecho: tres. La ficha aguanta cinco. «Ver más»
 * suelta otro tanto de las anteriores, no el resto de golpe.
 */
export const VENTANA_NOTAS_COMPACTA = 3
export const VENTANA_NOTAS = 5

export interface NotaOrdenable {
    id: number
    at: string | null
}

export function ordenarNotas<T extends NotaOrdenable>(notas: T[]): T[] {
    return [...notas].sort((a, b) => {
        const ta = a.at ?? ''
        const tb = b.at ?? ''
        if (ta !== tb) return tb.localeCompare(ta)
        return b.id - a.id
    })
}

export function ventanaDeNotas<T extends NotaOrdenable>(
    notas: T[],
    limite: number,
): { visibles: T[]; restantes: number } {
    const tope = Math.max(0, limite)
    const ordenadas = ordenarNotas(notas)
    return {
        visibles: ordenadas.slice(0, tope),
        restantes: Math.max(0, ordenadas.length - tope),
    }
}
